import { CASCADE_DROPDOWN_OPTIONS_SUCCESS } from "constants/actionTypes";

const intialState = {
  cascadingDropDownOptions: {},
  loading: false,
  errors: {} // Store errors for each cascade table ID
};

const cascaseDropDownOptions = (state = intialState, action: any) => {
  const { payload } = action;
  switch (action.type) {
    case CASCADE_DROPDOWN_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        cascadingDropDownOptions: {
          ...state.cascadingDropDownOptions, // Preserve existing values
          [payload.id]: payload.options // Merge new options for the specific field ID
        },
        errors: null // Clear errors on success
      };
    
    default:
      return state;
  }
};

export default cascaseDropDownOptions;